import React from 'react';
import { AttachmentsTable } from '@/components/tables/AttachmentsTable';
import { useObjectContext } from '@/hooks/useObjectContext';
import { AttachmentsContextProvider } from '@/context/attachmentsContext';

export const AttachmentsTab = () => {
	const { clientRow, insight, broker, dealRow, relationshipCompany } = useObjectContext();

	return (
		<AttachmentsContextProvider
			deal={dealRow}
			client={{ clientRow, insight, broker }}
			relationshipCompany={relationshipCompany}
		>
			<AttachmentsTable />
		</AttachmentsContextProvider>
	);
};
AttachmentsTab.displayName = 'AttachmentsTab';